(function () {

    "use strict";

    function basicService(masterDataService, $rootScope) {

        var vm = this;

        vm.instantiate = function (service) {

            service.masterData = masterDataService;

            service.toLocalDate = function (dateString) {
                return angular.isString(dateString) ? service.minDate() : new Date(new Date(dateString).toLocaleDateString());
            };

            service.toUtcString = function (date) {
                return date === service.minDate() ? null : date.toUTCString();
            };

            service.minDate = function () {
                return new Date("0001-01-01T00:00:00");
            };

            service.allDatesToUTCString = function (entity) {
                for (var entityProperty in entity) {
                    if (angular.isDate(entity[entityProperty])) {
                        entity[entityProperty] = service.toUtcString(entity[entityProperty]);
                    }
                }
                return entity;
            };

            service.configHead = function (items) {
                $rootScope.breadcrumb.items = items;
            };

        };

    }

    basicService.$inject = ["sphforms.masterDataService", "$rootScope"];

    angular.module("sphforms.main").service("sphforms.basicService", basicService);

})();
